import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';

class FormWithErrors extends Component
{
	state = {
		errors: [],
		values: []
	}

	constructor (props) {
		super(props);
	}

	onSubmit = (e) => {
		e.preventDefault();

		const that = this, value = e.target.value;
		if (this.props.onSubmit) {
			let submitted = this.props.onSubmit(value);
			if (submitted) {
				submitted.catch(function (errors) {
					that.setState({ errors: errors });
				});
			}
		}
	}

	render () {
		const that = this, inputs = this.props.children.map(function (children) {
			if (children.props && children.props.attr) {
				let childEl = that._renderitem(children);

				const totalErrors = that.state.errors;
				const attributeErrors = that.state.errors[children.props.attr]; 
				const doesAttributeHaveErrors = (totalErrors && attributeErrors && attributeErrors.length > 0);

				return (
					<section key={children.props.attr}>
						{React.cloneElement(
							childEl,
							{
								value: that.state.values[children.props.attr],
								onChange: (e) => {
									let curState = that.state;
									curState.values[children.props.attr] = e.target.value;
									that.setState(curState);
								} 
							}
						)}
						<div>
							{
								doesAttributeHaveErrors && 
								<ul>
								{
									attributeErrors.map(
										c => 
											<li key={children.props.attr + ".error"}>
												{c}
											</li>
									)
								}
								</ul>
							}
						</div>
					</section>
				);
			} else {
				return children;
			}
		});

		return (
			<form onSubmit={this.onSubmit}>
				{inputs}
			</form>
		);
	}

	_renderitem (children) {
		if (this.props.renderitem) {
			return this.props.renderitem(children);
		} else {
			return (
				<div className="field">
					{children}
				</div>
			);
		}
	}
}

export default FormWithErrors;


// WEBPACK FOOTER //
// ./src/Components/FormWithErrors.js